module.exports = __webpack_public_path__ + "static/media/dropdown.b1193b0e.svg";